
import heroBg from "../../assets/hero-bg.png";
import "./GalleryComponent.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import galleryImg1 from "../../assets/galery1.jpg"; 
import galleryImg2 from "../../assets/galery2.jpg"; 
import galleryImg3 from "../../assets/galery3.jpg"; 
import galleryImg4 from "../../assets/galery4.jpg"; 
import galleryImg5 from "../../assets/galery5.jpg"; 
import galleryImg6 from "../../assets/galery6.jpg";
import { useEffect, useState } from "react";

const GalleryPage = () => {
  


  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Array of your imported images
  const galleryImages = [
    galleryImg1,
    galleryImg2,
    galleryImg3,
    galleryImg4,
    galleryImg5,
    galleryImg6,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [galleryImages.length]);


  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    
    dotsClass: "slick-dots custom-dots" // We will style this class specifically
  };



    const journeyVideos = [
    "https://youtu.be/ROSqrTX9d9o?si=QUsq8BYHkOzIdmhf",
    "https://youtu.be/3FmOrF99yOQ?si=tCyZ8zO5JT6gGAGk",
    "https://youtu.be/RwVrsl3p5CU?si=-qj_zY9hnMAcpc0B",
    "https://youtu.be/Vo2U9SRwHt0?si=ahHRdXxHrC8GuoNR",
    "https://youtu.be/BweKJFa4b8g?si=xpz1kXG4Mytb5pka",
    "https://youtu.be/FtamU1FTvq0?si=DPz139ixrXqmzXgw",
    "https://youtu.be/Iogl0ImqMFI?feature=shared",
    "https://youtu.be/KYIXpNFtKN0?feature=shared",
    "https://youtu.be/iQlwE-L24fg?si=q3UOyBhzvEhBpSA-",
    "https://youtu.be/ZxPfSiK1pZg?si=kJcuo3dD-_a5HVFO",
    "https://youtu.be/fKEfs4H2els?si=mNoK8qNX5zRIzUI2"
  ];


 

  // Function to get YouTube embed URL
  const getYouTubeEmbedUrl = (url) => {
    if (url.includes("embed/")) {
      return url;
    }

    let videoId = "";

    if (url.includes("youtube.com/watch")) {
      const urlParams = new URLSearchParams(new URL(url).search);
      videoId = urlParams.get("v");
    } else if (url.includes("youtube.com/shorts/")) {
      videoId = url.split("shorts/")[1]?.split("?")[0];
    } else if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1]?.split("?")[0];
    }

    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    }

    return url;
  };

  return (
    <div className="gallery-page">
      {/* Hero */}
      <div className="about-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <h1 className="hero-content">GALLERY</h1>
      </div>

     {/* --- Gallery Slideshow Section --- */}
      <div className="gallery-static-section">
        <h2 className="static-section-title">Gallery</h2>
        
        <div className="gallery-image-container">
          <img 
            key={currentImageIndex} 
            src={galleryImages[currentImageIndex]} 
            alt={`Gallery Slide ${currentImageIndex + 1}`} 
            className="gallery-static-image fade-animation" 
          />
        </div>
      </div>


            {/* --- TESTIMONIALS SECTION --- */}
      <div className="testimonials-section">
        
        {/* 1. HEADER (Hashtag + Title) */}
        <div className="testimonials-header">
          <span className="hashtag">#Testimonials</span>
          <h2 className="main-heading">
            Reflections From The Visionaries Of Our Community
          </h2>
        </div>

        {/* 2. CAROUSEL (Vertical Video Only) */}
        <div className="carousel-wrapper">
          <Slider {...settings}>
            {/* Slide 1 */}
            <div className="video-slide">
              <iframe 
                className="vertical-video" 
                src={getYouTubeEmbedUrl("https://youtube.com/shorts/yzBedBRG7UQ?feature=shared")} 
                title="Testimonial 1"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            
            {/* Slide 2 */}
            <div className="video-slide">
              <iframe 
                className="vertical-video" 
                src={getYouTubeEmbedUrl("https://youtube.com/shorts/Dq7unkcwcQQ?feature=shared")} 
                title="Testimonial 2"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>

            {/* Slide 3 */}
            <div className="video-slide">
              <iframe 
                className="vertical-video" 
                src={getYouTubeEmbedUrl("https://youtube.com/shorts/ly-cCFbUaAo?feature=shared")} 
                title="Testimonial 3"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </Slider>
        </div>
      </div>



                 {/* --- Our Journey Since 2020 --- */}
      <div className="journey-section">
        <h2 className="journey-title">Our Journey Since 2020</h2>
        
        <div className="journey-container">
          {journeyVideos.map((url, index) => (
            <div className="journey-video-card" key={index}>
              <div className="video-embed-wrapper">
                <iframe
                  className="journey-video"
                  src={getYouTubeEmbedUrl(url)}
                  title={`Journey Video ${index + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          ))}
        </div>
      </div>


    </div>
  );
};

export default GalleryPage;
